import { TopBar } from '@/layouts/TopBar';
import CVVideoList from '@cv-videos/components/CVVideoList';
import useGetCvVideosList from '@cv-videos/hooks/useGetCvVideosList';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CVVideosPage = () => {
  const { t } = useTranslation();
  const { cvVideosCount } = useGetCvVideosList();

  return (
    <>
      <TopBar title={t('CV_VIDEOS')} count={cvVideosCount}></TopBar>
      <Box m={2}>
        <CVVideoList />
      </Box>
    </>
  );
};

export default CVVideosPage;
